import React from 'react';
const PRODUCTS = [{
  name: 'Bioidentical Estrogen',
  description: 'Custom-compounded, plant-derived',
  price: 49,
  illustration: <svg width="120" height="120" viewBox="0 0 120 120" fill="none" className="mx-auto" data-id="element-439">
        <rect x="45" y="20" width="30" height="60" rx="8" stroke="#9B4722" strokeWidth="2" fill="#F2E9DB" fillOpacity="0.3" data-id="element-440" />
        <rect x="50" y="15" width="20" height="8" rx="2" stroke="#9B4722" strokeWidth="2" fill="none" data-id="element-441" />
        <line x1="60" y1="23" x2="60" y2="50" stroke="#9B4722" strokeWidth="2" strokeLinecap="round" data-id="element-442" />
        <circle cx="60" cy="52" r="3" fill="#9B4722" data-id="element-443" />
      </svg>
}, {
  name: 'Progesterone Patch',
  description: 'Transdermal, once weekly',
  price: 39,
  illustration: <svg width="120" height="120" viewBox="0 0 120 120" fill="none" className="mx-auto" data-id="element-444">
        <rect x="30" y="35" width="60" height="50" rx="12" stroke="#9B4722" strokeWidth="2" fill="#F2E9DB" fillOpacity="0.3" data-id="element-445" />
        <circle cx="60" cy="60" r="15" stroke="#9B4722" strokeWidth="2" fill="none" data-id="element-446" />
        <circle cx="60" cy="60" r="8" fill="#9B4722" fillOpacity="0.2" data-id="element-447" />
      </svg>
}, {
  name: 'Vaginal Estradiol Cream',
  description: 'For intimate comfort',
  price: 35,
  illustration: <svg width="120" height="120" viewBox="0 0 120 120" fill="none" className="mx-auto" data-id="element-448">
        <path d="M 40 70 Q 45 50 50 40 L 70 40 Q 75 50 80 70 L 75 75 L 45 75 Z" stroke="#9B4722" strokeWidth="2" fill="#F2E9DB" fillOpacity="0.3" data-id="element-449" />
        <rect x="48" y="35" width="24" height="8" rx="2" stroke="#9B4722" strokeWidth="2" fill="none" data-id="element-450" />
        <line x1="50" y1="75" x2="55" y2="80" stroke="#9B4722" strokeWidth="2" strokeLinecap="round" data-id="element-451" />
        <line x1="60" y1="75" x2="60" y2="82" stroke="#9B4722" strokeWidth="2" strokeLinecap="round" data-id="element-452" />
        <line x1="70" y1="75" x2="65" y2="80" stroke="#9B4722" strokeWidth="2" strokeLinecap="round" data-id="element-453" />
      </svg>
}, {
  name: 'Testosterone Capsules',
  description: 'Energy, libido, mood',
  price: 42,
  illustration: <svg width="120" height="120" viewBox="0 0 120 120" fill="none" className="mx-auto" data-id="element-454">
        <rect x="40" y="30" width="40" height="55" rx="6" stroke="#9B4722" strokeWidth="2" fill="#F2E9DB" fillOpacity="0.3" data-id="element-455" />
        <rect x="45" y="25" width="30" height="8" rx="2" stroke="#9B4722" strokeWidth="2" fill="none" data-id="element-456" />
        <ellipse cx="52" cy="50" rx="4" ry="7" fill="#9B4722" fillOpacity="0.4" data-id="element-457" />
        <ellipse cx="62" cy="55" rx="4" ry="7" fill="#9B4722" fillOpacity="0.4" data-id="element-458" />
        <ellipse cx="68" cy="48" rx="4" ry="7" fill="#9B4722" fillOpacity="0.4" data-id="element-459" />
        <ellipse cx="57" cy="65" rx="4" ry="7" fill="#9B4722" fillOpacity="0.4" data-id="element-460" />
      </svg>
}];
export function TreatmentsCatalog() {
  return <section className="w-full bg-orla-bone py-32 md:py-[128px] px-6" data-id="element-461">
      <div className="max-w-[1240px] mx-auto" data-id="element-462">
        {/* Header */}
        <div className="flex flex-row justify-between items-end mb-12" data-id="element-463">
          <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-[-0.02em] leading-tight" data-id="element-464">
            Browse Orla's treatments.
          </h2>
          <a href="#" className="hidden md:block font-body font-semibold text-[15px] text-orla-saffron hover:underline transition-all duration-200" data-id="element-465">
            Shop all →
          </a>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16 md:overflow-visible overflow-x-auto snap-x snap-mandatory md:snap-none" data-id="element-466">
          {PRODUCTS.map((product, index) => <div key={index} className="bg-orla-surface rounded-2xl shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-out cursor-pointer overflow-hidden snap-start min-w-[calc(83.33%-12px)] md:min-w-0" data-id="element-467">
              {/* Product Image */}
              <div className="aspect-square flex items-center justify-center" style={{
            background: 'linear-gradient(135deg, #F2E9DB 0%, #FAF5EC 100%)'
          }} data-id="element-468">
                {product.illustration}
              </div>

              {/* Product Info */}
              <div className="p-6" data-id="element-469">
                <h3 className="font-display font-semibold text-[20px] text-orla-ink mb-2" data-id="element-470">
                  {product.name}
                </h3>
                <p className="font-body text-[14px] text-orla-muted line-clamp-1 mb-4" data-id="element-471">
                  {product.description}
                </p>
                <div className="mb-3" data-id="element-472">
                  <span className="font-body text-[13px] text-orla-muted" data-id="element-473">
                    Starts at{' '}
                  </span>
                  <span className="font-body font-semibold text-[16px] text-orla-sienna" data-id="element-474">
                    ${product.price}/mo
                  </span>
                </div>
                <a href="#" className="font-body font-semibold text-[14px] text-orla-saffron hover:underline transition-all duration-200" data-id="element-475">
                  Learn more →
                </a>
              </div>
            </div>)}
        </div>

        {/* CTA Button */}
        <div className="flex justify-center" data-id="element-476">
          <button className="bg-orla-sienna text-orla-bone font-body font-semibold text-[15px] px-8 py-[14px] rounded-full hover:opacity-90 transition-opacity duration-200" data-id="element-477">
            Shop All Treatments
          </button>
        </div>
      </div>
    </section>;
}